import { __APP_NAME__ } from "config/static";

export default function Footer() {
  return (
    <div className={`self-end flex justify-center w-full mt-5_ ${"md:px-2"}`}>
      <footer
        className={`w-full shadow max-w-6xl px-6 py-2 mx-auto h-16 bg-mainLight md:rounded-t-3xl dark:bg-gray-800 my-auto flex items-center `}
      >
        <div
          className={`w-full m-auto flex justify-center flex-col md:flex-row items-center md:justify-between`}
        >
          <span className="text-sm font-bold text-white sm:text-center dark:text-gray-400 mx-auto">
            <a
              href="https://www.facebook.com/share/16MoDb7K1u/"
              target="_blank"
              className="hover:underline mr-4"
            >
              {__APP_NAME__} ...
            </a>{" "}
            بدل عملتك بكل سهولة ...
          </span>

          {/* <span className="text-sm font-bold text-gray-500 sm:text-center dark:text-gray-400">
            تصميم وتطوير{" "}
            <a
              href="https://wa.me/963960062941"
              target="_blank"
              className="text-yellow-500/80 hover:underline"
            >
              byRings
            </a>
          </span> */}
          {/* <ul className="flex flex-wrap items-center mt-3 text-sm font-medium text-gray-500 dark:text-gray-400 sm:mt-0">
            <li>
              <a href="#" className="hover:underline">
                Contact
              </a>
            </li>
          </ul> */}
        </div>
      </footer>
    </div>
  );
}
